<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M10.18,18.41,3,9.77V4.65L7.08,1h5.84L17,4.65V9.79Z"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <circle cx="10" cy="8" r="2" fill="currentColor" />
  </svg>
</template>
